import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, ArrowRightIcon } from 'lucide-react';
export const Footer: React.FC = () => {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle newsletter subscription logic
    alert(`Täname teid tellimuse eest aadressil ${email}!`);
    setEmail('');
  };
  return <footer className="bg-gray-100 dark:bg-gray-900 pt-12 pb-6" data-id="element-57">
      <div className="container mx-auto px-4" data-id="element-58">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-59">
          {/* Company Info */}
          <div data-id="element-60">
            <h3 className="text-xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-61">
              Annelinna<span className="text-yellow-500" data-id="element-62">Pandimaja</span>
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-63">
              Teie usaldusväärne turg kvaliteetsete kasutatud
              elektroonikaseadmete ja investeerimisklassi väärismetallide jaoks.
            </p>
            <div className="flex space-x-4" data-id="element-64">
              <a href="#" className="text-gray-500 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-65">
                <FacebookIcon size={20} data-id="element-66" />
              </a>
              <a href="#" className="text-gray-500 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-67">
                <TwitterIcon size={20} data-id="element-68" />
              </a>
              <a href="#" className="text-gray-500 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-69">
                <InstagramIcon size={20} data-id="element-70" />
              </a>
              <a href="#" className="text-gray-500 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-71">
                <LinkedinIcon size={20} data-id="element-72" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-73">
            <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white" data-id="element-74">
              Kiirlingid
            </h3>
            <ul className="space-y-2" data-id="element-75">
              <li data-id="element-76">
                <Link to="/category/electronics" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-77">
                  Elektroonika
                </Link>
              </li>
              <li data-id="element-78">
                <Link to="/category/gold" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-79">
                  Kuld
                </Link>
              </li>
              <li data-id="element-80">
                <Link to="/category/silver" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-81">
                  Hõbe
                </Link>
              </li>
              <li data-id="element-82">
                <Link to="/category/platinum" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-83">
                  Plaatina
                </Link>
              </li>
              <li data-id="element-84">
                <Link to="/category/technical-tools" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-85">
                  Tehnilised Tööriistad
                </Link>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-86">
            <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white" data-id="element-87">
              Ettevõte
            </h3>
            <ul className="space-y-2" data-id="element-88">
              <li data-id="element-89">
                <Link to="/about" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-90">
                  Meist
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/contact" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-92">
                  Kontakt
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/privacy" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-94">
                  Privaatsuspoliitika
                </Link>
              </li>
              <li data-id="element-95">
                <Link to="/terms" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-96">
                  Kasutustingimused
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/faq" className="text-gray-600 hover:text-yellow-500 dark:text-gray-400 dark:hover:text-yellow-500" data-id="element-98">
                  KKK
                </Link>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-99">
            <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white" data-id="element-100">
              Uudiskiri
            </h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-101">
              Telli meie uudiskiri, et saada värskeid tooteuuendusi ja
              väärismetallide hinnateavet.
            </p>
            <form onSubmit={handleSubmit} className="flex" data-id="element-102">
              <input type="email" placeholder="Sinu e-post" value={email} onChange={e => setEmail(e.target.value)} className="flex-grow px-4 py-2 rounded-l-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500" required data-id="element-103" />
              <button type="submit" className="px-4 py-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded-r-md focus:outline-none focus:ring-2 focus:ring-yellow-500 flex items-center" data-id="element-104">
                <ArrowRightIcon size={16} data-id="element-105" />
              </button>
            </form>
          </div>
        </div>
        <div className="border-t border-gray-200 dark:border-gray-700 pt-6" data-id="element-106">
          <p className="text-center text-gray-600 dark:text-gray-400" data-id="element-107">
            &copy; {new Date().getFullYear()} Annelinna Pandimaja. Kõik õigused
            kaitstud.
          </p>
        </div>
      </div>
    </footer>;
};